import { createTheme } from "@mui/material/styles";

const myTheme = createTheme({
  palette: {
    primary: {
      main: "#252525",
    },
    blue: {
      main: "#5A589C",
      secondary: "#120F49",
    },
    white: {
      main: "#FFFFFF",
      light: "#F7FAFC",
    },
    grey: {
      main: " #A2A0B5",
      light: "#D9F4FD",
      secondary: "#607D8B",
      primary: "#919BA7",
    },

    yellow: {
      main: "#D2B581",
      light: "#FDCF7A",
      secondary: "#FAD97F",
    },
    purple: {
      main: "#3F3E62",
      light: "#5A589C",
    },
    black: {
      main: "#000000",
      light: "#272727",
    },
  },
  typography: {
    heading: {
      fontStyle: "normal",

      fontWeight: 700,
      fontSize: "56px",

      textTransform: "uppercase",
    },
    body: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "26px",
      lineHeight: "40px",
    },
  },
  Button: {
    main: {
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "18px",

      padding: "15px 25px",
      borderRadius: "31px",
    },
  },
  label: {
    main: {
      fontSize: " 14px",
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      marginBottom: "8px !important",
      color: "blue !important",
    },
  },
});
export default myTheme;
